import type { ReferenceLookupPorts } from "./reference-lookup";

const PLAYBACK_TIMEOUT_MS = 15_000;

export const playReferenceAudio: ReferenceLookupPorts["play"] = (
  pronunciation,
  signal,
) =>
  new Promise<void>((resolve, reject) => {
    if (signal.aborted) {
      reject(new Error("Pronunciation cancelled"));
      return;
    }
    if (!pronunciation.audioUrl) {
      reject(new Error("Pronunciation has no recording"));
      return;
    }
    const audio = new Audio(pronunciation.audioUrl);
    let finished = false;
    const finish = (error?: Error): void => {
      if (finished) return;
      finished = true;
      clearTimeout(timeout);
      signal.removeEventListener("abort", onAbort);
      audio.removeEventListener("ended", onEnded);
      audio.removeEventListener("error", onError);
      audio.pause();
      audio.removeAttribute("src");
      audio.load();
      if (error) reject(error);
      else resolve();
    };
    const onAbort = (): void => finish(new Error("Pronunciation cancelled"));
    const onEnded = (): void => finish();
    const onError = (): void =>
      finish(new Error("Pronunciation playback failed"));
    const timeout = setTimeout(
      () => finish(new Error("Pronunciation playback timed out")),
      PLAYBACK_TIMEOUT_MS,
    );
    signal.addEventListener("abort", onAbort, { once: true });
    audio.addEventListener("ended", onEnded, { once: true });
    audio.addEventListener("error", onError, { once: true });
    try {
      void audio
        .play()
        .catch(() =>
          finish(new Error("Pronunciation playback could not start")),
        );
    } catch {
      finish(new Error("Pronunciation playback could not start"));
    }
  });
